module.exports = __webpack_public_path__ + "img/hidden.453546a0.svg";